import React from 'react';

import styles from '../styles/Contacts.module.css';
import sprite from '../../public/sprite.svg';


interface SupportItem {
  icon: string;
  prefix: string;
  value: string | undefined;
}

interface SupportConfig {
  phone?: SupportItem;
  mobile?: SupportItem;
  email?: SupportItem;
}

interface ContactsProps {
  pub?: boolean;
}

const support: SupportConfig = {
    phone: { icon: 'phone', prefix: 'tel:', value: process.env.SUPPORT_PHONE },
    mobile: { icon: 'iphone', prefix: 'tel:', value: process.env.SUPPORT_MOBILE},
    email: { icon: 'mail', prefix: 'mailto:', value: process.env.SUPPORT_EMAIL},
} as const;

const Contacts: React.FC<ContactsProps> = ({ pub }) => {

    return (
        <div className={pub ? styles.pubContacts : styles.contacts}>
            <ul className={pub ? styles.publicContactsItems : styles.contactsItems}>
                <li>
                    <span>Години роботи:</span> (пн-нд 9:00 - 18:00)
                </li>
                {Object.entries(support).map(([key, item]) => {
                    if (!item?.value) return null;

                    return (
                        <li key={key} className={styles.contactsActive}>
                            <a href={`${item.prefix}${item.value.replace(/\s+/g, '')}`}>
                                <svg className={styles.icons}>
                                <use href={`${sprite}#${item.icon}`} />
                                </svg>
                                {item.value}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Contacts;
